<template>
  <div class="swipe">
    <z-swipe class="z-swipe" :autoplay="2500" :show-indicators="false" :loop="true" vertical>
      <z-swipe-item v-for="(item, index) in guideInfoList" :key="item.text + index">
        <div class="swipe-item">
          <div v-if="item.imageList">
            <img
              v-for="(e, idx) in item.imageList"
              :key="idx"
              v-lazy="$setPicSize(e, 28, 28)"
              :style="{ 'z-index': `${10 + idx}`, right: `${6 * idx}px` }"
              alt=""
            />
          </div>
          <span class="text" :class="{ active: item.clickable }">{{ item.text }}</span>
        </div>
      </z-swipe-item>
    </z-swipe>
  </div>
</template>

<script>
import Vue from 'vue'
import { defineComponent, onMounted } from '@vue/composition-api'
import { Swipe, SwipeItem } from '@zz-common/zz-ui'
Vue.use(Swipe).use(SwipeItem)

export default defineComponent({
  props: {
    guideInfoList: {
      type: Array,
      default: () => []
    }
  },
  setup(props, ctx) {
    const { $tiktok } = ctx.root
    $tiktok('created', 'guidSwiper')
    onMounted(() => {
      $tiktok('mounted', 'guidSwiper')
    })
  }
})
</script>

<style lang="scss" scoped>
.swipe {
  box-sizing: border-box;
  width: 300px;
  height: 48px;
  margin-top: 4px;
  margin-left: 15px;
  padding-left: 10px;
  color: rgba(0, 0, 0, 0.5);
  background: rgba(255, 255, 255, 0.8);

  border-radius: 32px;
  .z-swipe {
    height: 48px;
    line-height: 48px;
  }
  .swipe-item {
    display: flex;
    align-items: center;
    width: 100%;
    height: 48px;
    > div {
      display: flex;
      align-items: center;
      width: 84px;
    }
    img {
      position: relative;
      width: 28px;
      height: 28px;
      border: 2px solid #fff;
      border-radius: 50%;
    }
    .text {
      position: relative;
      color: #999999;
      font-weight: 300;
      font-size: 20px;
      font-family: PingFangSC-Light, PingFang SC;
      line-height: 48px;
    }
  }
}
</style>
